import type { ICursor } from '@/types/cursor'
import type { IProduct } from '@/types/product'
import ProductsListItem from './products.list.item'

import Section from '@/components/ui/atoms/Section'
import Pagination from '@/components/ui/molecules/pagination'
import { ListImpression } from '@/tracking/impression'
import type { IPaymentStandard } from '@/types/payment'
import { useEffect } from 'react'

export default function ProductsList({
  products,
  cursor,
  payment,
  type,
  search,
  pathname,
}: {
  products: Array<IProduct>
  cursor: ICursor
  payment: IPaymentStandard
  type: string
  search?: string
  pathname: string
}) {
  const current = new URLSearchParams(search)
  const parsed = current.toString()
  const query = parsed ? `?${parsed}` : ''

  useEffect(() => {
    const items = products.map((product) => {
      const type: 'Módulo' | 'Curso' | 'Combo' =
        product.type === 'course'
          ? 'Curso'
          : product.type === 'combo'
            ? 'Combo'
            : 'Módulo'

      return {
        Produto: product.name,
        ProdutoID: product._id,
        Tipo: type,
        Valor: product.price,
        Instituicao: product.institution,
        Carreira: product?.career || '',
        Cargo: product?.role,
        Formacao: product?.formation,
        Edital: product?.situation,
        Desconto:
          (product.discountedPrice || product.price) *
          (1 - (payment?.in_cash?.greater || 0) / 100),
      }
    })

    ListImpression({
      type: type === 'curso' ? 'Curso' : 'Módulo',
      items,
    })
  }, [products])

  const id = ['curso', 'combo'].includes(type) ? 'course' : 'module'

  return (
    <Section id={`${id}-list`}>
      <span className="flex gap-2 text-sm">
        {!cursor?.total && (
          <>Nenhum {type} encontrado para os filtros aplicados</>
        )}
      </span>
      <div className="grid px-2 sm:px-0 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 my-6">
        {products.map((product: IProduct) => (
          <div key={product._id}>
            <ProductsListItem product={product} payment={payment} />
          </div>
        ))}
      </div>
      {cursor?.total && cursor?.page && cursor?.pages && cursor?.pages > 1 ? (
        <Pagination
          total={cursor?.total}
          page={cursor?.page}
          pages={cursor?.pages}
          object={type}
          pathname={pathname}
          query={query}
        />
      ) : (
        <></>
      )}
    </Section>
  )
}
